import React from 'react';
import "./EnvBanner.scss"

const EnvBanner = () => {
  const envType = window.config.envType !== undefined ? window.config.envType : 2;
  switch (envType) {
    case 0:
      return (
        <div className='env-banner'>
          <div className='env-banner-text'>VÝVOJOVÉ PROSTREDIE</div>
        </div>
      );
    case 1:
      return (
        <div className='env-banner'>
          <div className='env-banner-text'>TESTOVACIE PROSTREDIE</div>
        </div>
      );
    default:
      return null;
  }
}

export default EnvBanner;